export class QueryMetadata {
    PageSize: number;
    PageNumber: number;
    Sort: QuerySort;

    constructor() {
        this.PageSize = 0;
        this.PageNumber = 0;
        this.Sort = new QuerySort();
    }
}

export class QuerySort {
    Sort: string | null;
    ColID: string | null;

    constructor() {
        this.Sort = null;
        this.ColID = null;
    }
}
